import { CardList } from "../styles";
import ApplicationCard from "../Cards/ApplicationCard";
import { CardMenu } from "../Cards/BaseCard";
import { CustomApps } from "./UserCards";
import { useDepartmentList, useUnifyUserProfile } from "../../hooks/queries";
import { getActiveLinks } from "../../util/getActiveLinks";

export function UserCardsList({ userCardList, menuOptions, menuHandler }: {
    userCardList: CustomApps,
    menuOptions: CardMenu[],
    menuHandler: Function
}) {
    const { data: userProfile } = useUnifyUserProfile();
    const departmentTypes = userProfile?.departmentTypes;
    const { data: departmentList } = useDepartmentList();

    const activeLinks = getActiveLinks(userCardList, departmentTypes, departmentList);

    return (
        <>
            <CardList>
                {activeLinks.map((app: any) => <ApplicationCard
                        key={app.appId}
                        name={app.name || ''}
                        description={app.description || ''}
                        url={app.url || ''}
                        isEnabled
                        iconColor="#000"
                        onCardOpen={() => window.open(app.url, "_blank")}
                        iconText={app.iconText || ''}
                        id={app.appId || ''}
                        menu={menuOptions}
                        menuHandler={(option: CardMenu) => { menuHandler(option, { ...app }) }}
                        hideStartupOption={true}
                        isCustomLink
                    />)
                }
            </CardList>

        </>
    )
}